import React from 'react'
import DatePickerInput from '@/components/atoms/DatePickerInput/DatePickerInput'
import { convertToUTC } from '../validations'
import { getStartDateSchema, getEndDateSchema } from '../schemas'

/**
 * AvailabilitySection component for reward start and end dates
 * @param {Object} props - Component props
 * @param {Object} props.formData - Form data containing startDate and endDate
 * @param {Function} props.handleFormChange - Function to handle form field changes
 * @param {Function} props.handleValidation - Function to handle validation state
 * @returns {JSX.Element} The rendered AvailabilitySection component
 */
const AvailabilitySection = ({ formData, handleFormChange, handleValidation }) => {
  const handleStartDateChange = (value, isValid) => {
    // Convert to UTC for API storage
    const utcValue = value ? convertToUTC(value) : null
    handleFormChange('startDate', utcValue)
    handleFormChange('startDateDisplay', value) // Keep display format for UI
    
    // Update validation state
    handleValidation('startDate', !isValid)
  }

  const handleEndDateChange = (value, isValid) => {
    // Convert to UTC for API storage
    const utcValue = value ? convertToUTC(value) : null
    handleFormChange('endDate', utcValue)
    handleFormChange('endDateDisplay', value) // Keep display format for UI
    
    // Update validation state
    handleValidation('endDate', !isValid)
  }

  const startDateSchema = getStartDateSchema(formData)
  const endDateSchema = getEndDateSchema(formData)

  return (
    <div className="flex flex-col gap-6">
      <h3 className="text-base font-bold text-white">Availability</h3>
      
      <div className="flex flex-col md:flex-row items-start gap-6">
        <DatePickerInput
          value={formData?.startDateDisplay || ''}
          updateValue={handleStartDateChange}
          uiSchema={startDateSchema}
          id="start_date"
        />
        <DatePickerInput
          value={formData?.endDateDisplay || ''}
          updateValue={handleEndDateChange}
          uiSchema={endDateSchema}
          id="end_date"
        />
      </div>
    </div>
  )
}

export default AvailabilitySection
